
import { ViewHeader, Card, Pagination, Table, useGet } from '@enkla-gui'
import { icons } from '@config'

export default function Settings() {
  const { data: configs, loading, sorting, setSorting, setPage } = useGet({ endpoint: 'api/invoicingconfig' })
  return (
    <>
      <ViewHeader
        title='Inställningar'
        subtitle='Hyresavisering'
        icon={icons.invoice}
        loading={loading}
      />
      <Card>
        <Table
          rows={configs}
          link={`/#!/company/@{company_id}/invoicingconfig`}
          functions={{
            bool: val => <span class={`badge w-100 bg-${val !== null ? 'success' : 'danger'}`}>{val != null ? 'Aktivt' : 'Inaktivt'}</span>,
          }}
          keys={['company.name', 'invoice_method', 'generate_day>function:bool', 'send_day>function:bool']}
        >
          <th>Företag</th>
          <th>Fakturametod</th>
          <th>Automatisk generering</th>
          <th>Automatiskt utskick</th>
        </Table>
      </Card>
    </>
  )
}
